import React, { useState, useEffect } from 'react';
import { getSingleBulkPrice } from '../services/NavisionPriceService';
import { translate } from '../../../Services/translation';
import clsx from 'clsx';

const DEFAULT_STATE: ProductBulkPriceResponse = {
  errorMessage: '',
  success: false,
  items: [],
};

const NavisionSingleBulkPrice = ({
  productId,
  litiumPrice,
  currency,
  productFee,
}: {
  productId: string;
  litiumPrice: string;
  currency: string;
  productFee: [
    { feeTypeName: string; priceModel: { formattedPrice: string } }
  ];
}) => {
  const [bulkPrices, setBulkPrices] = useState<ProductPriceResponseItem[]>(
    DEFAULT_STATE.items
  );

  useEffect(() => {
    const fetchPrices = async () => {
      if (bulkPrices.length == 0) {
        var res = await getSingleBulkPrice(productId);
        var prices = await res.json();
        setBulkPrices(prices);
      }
    };
    fetchPrices();
  }, []);

  const formattedNavisionPrice =
    bulkPrices[0]?.formattedPrice ??
    translate('product.placeholder.fetching.price');

  return (
    <>
      <div className="flex flex-col">
        <h4>{formattedNavisionPrice}</h4>
        <p className="text-md text-gray-600">
          {translate('product.recommended-price')} {litiumPrice}
        </p>
        {productFee &&
          productFee.length > 0 &&
          productFee.map((fee) => (
            <p
              className={clsx('text-md', 'text-gray-600')}
              key={fee.feeTypeName}
            >
              {translate('product.fee')} ({fee.feeTypeName}){': '}
              {fee.priceModel.formattedPrice}
            </p>
          ))}
        <meta itemProp="price" content={formattedNavisionPrice} />
        <meta itemProp="currency" content={currency} />
      </div>
    </>
  );
};

export default NavisionSingleBulkPrice;
